import React from 'react';
import { connect } from 'react-redux';
import { addToFavorites, removeFromFavorites } from '../../actions/favoritesPageActions';
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { CollapsibleText } from '../../components/CollapsibleDropDown/CollapsibleText';
import { cruiseList } from '../../components/Recommendation/recommendation';
import RecommendationSection from '../../components/Recommendation/RecommendationSection';
import { ShipPosition } from '../../components/ShipPosition/ShipPosition';
import { __ } from '../../helpers/TranslationService';
import { IShipLivePositionPageReducer } from '../../interfaces/IShipLivePosition';
import { IPageDataReducer } from '../../reducers/pageData';
import { IRouterReducer } from '../../reducers/router';
import { Webcams } from './components/Webcams';
import { config } from '../../config';
import { ShipPositionInfo } from '../../components/ShipPosition/ShipPositionInfo';
import loadable from '@loadable/component';
const MapboxMap = loadable(() => import('../Cruise/components/MapboxMap'), {
    ssr: false,
});

interface State {
    isComponentLoaded: boolean;
}

interface StateProps {
    shipLivePositionPage: IShipLivePositionPageReducer;
    pageData: IPageDataReducer;
    router: IRouterReducer;
    favorites: number[];
}

interface DispatchProps {
    addToFavorites(nid): () => void;
    removeFromFavorites(nid): () => void;
}

type Props = StateProps & DispatchProps;

class ShipLivePositionPageClass extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            isComponentLoaded: false,
        };
    }

    componentDidMount() {
        this.setState({ isComponentLoaded: true });
    }

    render() {
        const {
            shipId,
            shipTitle,
            webcams,
            cruiseRecommendations,
            webcamFreetextField,
            breadcrumbs,
            shipPosition,
        } = this.props.shipLivePositionPage;

        const teaserTracking = {
            category: 'mobile-teaser-shiplivepositionpage',
            label: 'ship',
        };

        const isDesktop = this.props.pageData.deviceType === 'desktop';

        const recommendationProps = {
            pageData: this.props.pageData,
            cruiseRecommendations: cruiseRecommendations,
            trackingData: teaserTracking,
        };

        const breadcrumbsStyle = {
            marginTop: webcamFreetextField && webcamFreetextField.length > 0 ? 5 : 15,
        };

        const offerUrl = `/${
            this.props.pageData.brandConfig.slugsObj.searchresults
        }?filterParams[ship][0]=${shipId.toString()}`;

        const Header = () => {
            const headline = __('%s position (ship page)', 'dreamlines', shipTitle);
            const subHeadline = __(
                'Here you can find all information around where the ship is currently located at',
                'dreamlines',
            );
            const style = {
                header: {
                    backgroundImage: `url(${config.images}/common/faq_contact_background.jpg)`,
                },
                icon: {
                    backgroundImage: `url(${config.images}/common/marker.svg)`,
                    backgroundSize: `50px 155px`,
                },
            };

            return (
                <div className="ship-live-position--header" style={style.header}>
                    <div className="ship-live-position--header-overlay" />
                    <div className="ship-live-position--header-data">
                        <span className="ship-live-position--header-icon" style={style.icon} />
                        <div className="roundtrip-responsive">
                            <h1>{headline}</h1>
                            <span dangerouslySetInnerHTML={{ __html: subHeadline }} />
                        </div>
                    </div>
                </div>
            );
        };

        const ShipPositionMap = () =>
            this.state.isComponentLoaded && (
                <MapboxMap
                    pageType="ship-position-page"
                    position={shipPosition}
                    countryCode="de"
                    title={'title here'}
                    markerMode="position"
                />
            );

        const ShipPositionInformation = () => (
            <div className="ship-live-position--container--information">
                <h3>
                    {shipTitle} {__('Itinerary', 'dreamlines')}
                </h3>
                <ShipPositionInfo position={shipPosition} />
            </div>
        );

        return (
            <div className="ship-live-position">
                <Header />

                {isDesktop ? (
                    <div className="ship-live-position--container">
                        <Breadcrumbs className="onlyTabletUp" breadcrumbs={breadcrumbs} />

                        <ShipPositionMap />

                        <ShipPositionInformation />

                        <Webcams webcams={webcams} shipTitle={shipTitle} />

                        <RecommendationSection
                            key={'Recommendation Section CruiseList'}
                            data={cruiseList(recommendationProps)}
                            title={__('%s Cruises', 'dreamlines', shipTitle)}
                            favorites={this.props.favorites}
                            addToFavorites={this.props.addToFavorites}
                            removeFromFavorites={this.props.removeFromFavorites}
                            offerUrl={offerUrl}
                        />
                    </div>
                ) : (
                    <div className="ship-live-position--container">
                        <ShipPosition
                            position={this.props.shipLivePositionPage}
                            showMapOnly={false}
                        />

                        <Webcams webcams={webcams} shipTitle={shipTitle} />

                        <RecommendationSection
                            key={'Recommendation Section CruiseList'}
                            data={cruiseList(recommendationProps)}
                            title={__('%s Cruises', 'dreamlines', shipTitle)}
                            favorites={this.props.favorites}
                            addToFavorites={this.props.addToFavorites}
                            removeFromFavorites={this.props.removeFromFavorites}
                        />

                        {webcamFreetextField && <CollapsibleText text={webcamFreetextField} />}

                        <div style={breadcrumbsStyle}>
                            <Breadcrumbs className="onlyMobile" breadcrumbs={breadcrumbs} />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

// @TODO Check state type
const mapStateToProps = (state: StateProps) => ({
    shipLivePositionPage: state.shipLivePositionPage,
    pageData: state.pageData,
    favorites: (state as any).favoritePage.favorites,
    router: state.router,
});
const mapDispatchToProps = {
    addToFavorites,
    removeFromFavorites,
};

// @TODO check dispatch types, they don't fit the declared value here
export const ShipLivePositionPage = connect<StateProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
)(ShipLivePositionPageClass);
export default ShipLivePositionPage;
